export const commitmentToSafety = require('images/expertise/wireline/CommitmentToSafety.webp');
export const comprehensiveFiberSolutions = require('images/expertise/wireline/ComprehensiveFiberSolutions.webp');
export const construction = require('images/expertise/wireline/Construction.webp');
export const engineeringExpertise = require('images/expertise/wireline/EngineeringExpertise.webp');
export const maintenanceRestoration = require('images/expertise/wireline/MaintenanceRestoration.webp');
export const oSPConstruction = require('images/expertise/wireline/OSPConstruction.webp');
export const precisionSplicingActivation = require('images/expertise/wireline/PrecisionSplicingActivation.webp');
export const wirelineHero = require('images/expertise/wireline/WirelineHero.webp');
